import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { ErrorBoundary } from './components/ErrorBoundary'
import { ServerHealthProvider } from './integrations/server-health-provider'
import * as TanStackQueryProvider from './integrations/tanstack-query/root-provider'
import { ToastProvider } from './integrations/toaster-provider'
import reportWebVitals from './reportWebVitals'
import { router } from './routes/index'
import './styles.css'

const TanStackQueryProviderContext = TanStackQueryProvider.getContext()

const rootElement = document.getElementById('app')
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <ErrorBoundary showErrorDetails={import.meta.env.DEV}>
        <ServerHealthProvider>
          <TanStackQueryProvider.Provider {...TanStackQueryProviderContext}>
            <RouterProvider router={router} />
          </TanStackQueryProvider.Provider>
          <ToastProvider />
        </ServerHealthProvider>
      </ErrorBoundary>
    </StrictMode>,
  )
}

reportWebVitals()
